import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Editor } from "@tinymce/tinymce-react";

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";

import Header from "components/Headers/Header";

function VariablesContrato() {
  const [postTipo, setPostTipo] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  const postData = async (e) => {
    e.preventDefault();

    if (!postTipo.trim() || !content.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Campos requeridos",
        text: "Por favor complete el tipo de contrato y la minuta.",
      });
      return;
    }

    try {
      setLoading(true);
      Swal.fire({
        title: "Enviando...",
        text: "Por favor espere",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://contratosback-dev.azurewebsites.net/api/v1/CreaTipoContrato",
        data: {
          tipoContrato: postTipo,
          minuta: content,
        },
      });

      Swal.fire("¡Éxito!", "Contrato creado con éxito.", "success");
      setTimeout(() => window.location.reload("/"), 1500);
    } catch (error) {
      Swal.fire("Error", "Error al crear: " + error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Tipo Contratos</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <FormGroup>
                  <label className="form-control-label">Tipo Contrato</label>
                  <Input
                    placeholder="Ej: Contrato de Prestación de Servicios"
                    type="text"
                    value={postTipo}
                    onChange={(e) => setPostTipo(e.target.value)}
                    disabled={loading}
                  />
                </FormGroup>

                <FormGroup>
                  <label className="form-control-label">Minuta</label>
                  <Editor
                    apiKey="dctsy3q1ism8sxejyno01cv605iqzbpyoggz0najurqlvcki"
                    init={{
                      height: 400,
                      menubar: true,
                      plugins: [
                        "advlist autolink lists link image charmap preview anchor",
                        "searchreplace visualblocks code fullscreen",
                        "insertdatetime media table help wordcount",
                      ],
                      toolbar:
                        "undo redo | formatselect | bold italic backcolor | " +
                        "alignleft aligncenter alignright alignjustify | " +
                        "bullist numlist outdent indent | removeformat | help | table image",
                      paste_data_images: true,
                      image_title: true,
                      automatic_uploads: true,
                      file_picker_types: "image",
                      file_picker_callback: function (cb, value, meta) {
                        const input = document.createElement("input");
                        input.setAttribute("type", "file");
                        input.setAttribute("accept", "image/*");

                        input.onchange = function () {
                          const file = input.files[0];
                          const reader = new FileReader();
                          reader.onload = function () {
                            const id = "blobid" + new Date().getTime();
                            const blobCache =
                              window.tinymce.activeEditor.editorUpload
                                .blobCache;
                            const base64 = reader.result.split(",")[1];
                            const blobInfo = blobCache.create(id, file, base64);
                            blobCache.add(blobInfo);
                            cb(blobInfo.blobUri(), { title: file.name });
                          };
                          reader.readAsDataURL(file);
                        };

                        input.click();
                      },
                    }}
                    value={content}
                    onEditorChange={(newContent) => setContent(newContent)}
                    disabled={loading}
                  />
                </FormGroup>

                <Button color="primary" onClick={postData} disabled={loading}>
                  {loading ? "Enviando..." : "ENVIAR"}
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default VariablesContrato;
